import { isPlatformServer } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
  PLATFORM_ID,
  StateKey,
  TransferState,
  inject,
  makeStateKey,
} from '@angular/core';

import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Observable, tap } from 'rxjs';

export class TranslatesBrowserLoaderService implements TranslateLoader {
  private platformId = inject(PLATFORM_ID);
  private http = inject(HttpClient);
  private transferState = inject(TransferState);

  public getTranslation(lang: string): Observable<TranslationObject> {
    const key: StateKey<TranslationObject> = makeStateKey<TranslationObject>(
      `transfer-translate-${lang}`,
    );
    const data = this.transferState.get(key, null);
    if (data) {
      return new Observable((observer) => {
        observer.next(data);
        observer.complete();
      });
    } else {
      const tran = new TranslateHttpLoader(this.http, '/assets/i18n/', '.json')
        .getTranslation(lang)
        .pipe(
          tap((translates) => {
            if (isPlatformServer(this.platformId)) {
              this.transferState.set(key, translates);
            }
          }),
        );
      return tran;
    }
  }
}
